import { GlButton, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { isLoggedIn } from '~/lib/utils/common_utils';
import ForksButton from '../../../forks/components/forks_button.vue?vue3';
import NotificationsDropdown from '../../../notifications/components/notifications_dropdown.vue?vue3';
import StarCount from '../../../stars/components/star_count.vue?vue3';
import getProjectByPath from '~/graphql_shared/queries/get_project_by_path.graphql';
import { ACTION_COPY_ID } from '~/vue_shared/components/list_actions/constants';
import { createAlert } from '../../../alert.js?vue3';
import { formatProject } from '../formatter.js?vue3';
import ProjectHeaderActions from './header_actions.vue?vue3';
export default {
    name: 'HomePanelApp',
    components: {
        ForksButton,
        GlButton,
        ProjectHeaderActions,
        NotificationsDropdown,
        StarCount
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        adminPath: {
            default: ''
        },
        canReadProject: {
            default: false
        },
        isProjectEmpty: {
            default: false
        },
        projectId: {
            default: ''
        },
        projectFullPath: {
            default: ''
        }
    },
    props: {
        canRequestAccess: {
            type: Boolean,
            required: true
        },
        canWithdrawAccessRequest: {
            type: Boolean,
            required: true
        },
        requestAccessPath: {
            type: String,
            required: true
        },
        withdrawAccessRequestPath: {
            type: String,
            required: true
        },
        dashboardPath: {
            type: String,
            required: true
        }
    },
    apollo: {
        project: {
            query: getProjectByPath,
            update (data) {
                return formatProject(data.project, {
                    canWithdrawAccessRequest: this.canWithdrawAccessRequest,
                    canRequestAccess: this.canRequestAccess,
                    requestAccessPath: this.requestAccessPath,
                    withdrawAccessRequestPath: this.withdrawAccessRequestPath
                });
            },
            variables () {
                return {
                    fullPath: this.projectFullPath
                };
            },
            error () {
                createAlert({
                    message: s__('GroupProjectActions|Something went wrong while loading the actions dropdown list. Please refresh the page and try again.')
                });
            },
            skip () {
                return !isLoggedIn();
            }
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn(),
            project: {
                id: this.projectId,
                availableActions: [
                    ACTION_COPY_ID
                ]
            }
        };
    },
    computed: {
        canForkProject () {
            return !this.isProjectEmpty && isLoggedIn() && this.canReadProject;
        },
        showActions () {
            return this.project && !this.$apollo.queries.project.loading;
        }
    },
    i18n: {
        adminButtonTooltip: __('View project in admin area')
    }
};
